import { useState } from "react";

import { BiMessageSquareAdd } from "react-icons/bi";
import { GiHamburgerMenu } from "react-icons/gi";
import {
  RiHome3Line,
  RiHomeSmileFill,
  RiMoneyDollarCircleLine,
  RiUserFill,
} from "react-icons/ri";
import { IoGift, IoQrCode } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router";
import { loading, loadingDestroy, openMenu } from "../../redux/action/action";
import { useDispatch } from "react-redux";
import { HiShare } from "react-icons/hi";
import { useTranslation } from "react-i18next";
import { MdEventAvailable, MdHistory } from "react-icons/md";
import usePwaDetected from "../../hook/usePwaDetected";
import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { openChat } from "../../redux/action/member/memberAction";
import useCheckLogin from "../../hook/useCheckLogin";
import { COMMON_WEB_PATH } from "../../constant";
import { NavLink } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`footer.${key}`);

  const { isLogin } = useCheckLogin();

  const isPwa = usePwaDetected();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const FOOTER_LIST = [
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/MemberCenter.svg`,
      text: "profile",
      link: "profile",
      image_name: "transaction",
      auth: true,
      font: "profile",
    },
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/GameRecords.svg`,
      image_hover: `${COMMON_WEB_PATH}/v4-layout/award2.svg`,
      //icon: <IoGift className={iconStyle} />,
      text: "Rewards",
      link: "profile/betRecord",
      auth: true,
      font: "betrecord",
    },
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/GameLobby.svg`,
      text: "home",
      link: "/",
      image_name: "record",
      font: "Game Lobby",
    },
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/favoriteICON.svg`,
      //image_hover: `${COMMON_WEB_PATH}/v4-layout/like2.svg`,
      //icon: <MdHistory className={iconStyle} />,
      text: "Favorite",
      link: "/profile/data",
      image_name: "transaction",
      auth: true,
      font: "favorite",
      wrapperClass: {
        ml: "5px",
      },
    },
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/pwaICON.svg`,
      text: "Profile",
      image_name: "profile",
      link: "profile",
      auth: true,
      hidden: !isPwa,
      font: "profile",
    },
    {
      image: `${COMMON_WEB_PATH}/911TW/menu/pwaICON.svg`,
      text: "PWAteach",
      image_name: "profile",
      link: "app",
      auth: true,
      hidden: isPwa,
      font: "PWAteach",
    },
  ];

  return (
    <Box as="footer" w="100%" position="fixed" bottom="0" left="0" zIndex={999}>
      <Box
        as="section"
        w="100%"
        h="65px"
        //bg={footerBg}
        //display="grid"
        // gridTemplateColumns="repeat(5, minmax(0, 1fr))"
        padding="0 0%"
        bgImage={`${COMMON_WEB_PATH}/911TW/footerBG3.webp`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        // gridTemplateColumns="repeat(5, minmax(0, 1fr))"
        // mx="auto"
        position="relative"
        borderTopRadius={"common"}
        //shadow="0px 11px 30px black"
        alignItems={`flex-start`}
        // justifyContent={`space-around`}
        // className="footer-shadow"
        pt="10px"
        // gap="15px"
      >
        {FOOTER_LIST?.filter((item) => !item.hidden)?.map((footer, index) => {
          const isHallIcon = footer.image?.includes("GameLobby");
          return (
            <Box
              as={NavLink}
              w={footer.text === "home" ? "30%" : "18%"}
              key={index}
              to={footer.link}
            >
              {(props) => {
                const isActive =
                  footer.text === "Menu" ? false : props.isActive; //Menu項目不要active

                return (
                  <Flex
                    alignItems="center"
                    flexDirection={`column`}
                    justifyContent="center"
                    position={isHallIcon ? "relative" : "static"}
                    top={isHallIcon ? "-20px" : "auto"} // 中間 icon 往上偏移
                    zIndex={isHallIcon ? 2 : 1}
                    gap="2.5px"
                    color={isActive ? "brand.500" : "#CFD1E1"}
                    onClick={() => {
                      if (footer.function) {
                        footer.function();
                        return;
                      }
                      if (footer.text === "Menu") {
                        dispatch(openMenu());
                      } else {
                        dispatch(loading());

                        setTimeout(() => {
                          navigate(`${footer.link}`);
                          dispatch(loadingDestroy());
                        }, 200);
                      }
                    }}
                    margin={footer.text === "home" ? "0 10px" : "0"}
                    maxW={footer.text === "home" ? "100px" : "100%"}
                  >
                    {footer.image ? (
                      <Image
                        src={footer.image}
                        _hover={{
                          filter: "brightness(1.5)",
                        }}
                        w={isHallIcon ? "50px" : "30px"} // hallICON 尺寸更大
                        h={isHallIcon ? "50px" : "30px"}
                        transform={isHallIcon ? "scale(1.5)" : "none"} // hallICON 放大
                        filter={
                          isActive
                            ? isHallIcon
                              ? "brightness(1.5)"
                              : "brightness(2)"
                            : "brightness(1)"
                        }
                      />
                    ) : (
                      <Box
                        transition="all 0.2s ease"
                        _hover={{
                          color: "brand.500",
                        }}
                      >
                        {footer.icon}
                      </Box>
                    )}
                    <Text
                      as="p"
                      mb="0px"
                      fontWeight={`medium`}
                      fontSize={`xs`}
                      w="100%"
                      textAlign="center"
                      color="#FAFAFA"
                      wordBreak={"keep-all"}
                      // className="text-overflow"
                    >
                      {i18n(footer.font)}
                    </Text>
                  </Flex>
                );
              }}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Footer;
